import React from 'react';

/**
 * SelectMode Component
 * 
 * Select from existing attachments list
 */
const SelectMode = ({
  isLoadingAttachments,
  attachments,
  selectedAttachmentId,
  setSelectedAttachmentId,
  formatSize,
}) => {
  if (isLoadingAttachments) {
    return (
      <div className="deliverable-submit-modal__select-mode">
        <div className="deliverable-submit-modal__loading">
          <div className="deliverable-submit-modal__spinner" />
          <span>Loading attachments...</span>
        </div>
      </div>
    );
  }

  if (attachments.length === 0) {
    return (
      <div className="deliverable-submit-modal__select-mode">
        <div className="deliverable-submit-modal__empty">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
          </svg>
          <p>No attachments yet</p>
          <span>Upload files via the Attachments button or use the Upload tab above.</span>
        </div>
      </div>
    );
  }

  return (
    <div className="deliverable-submit-modal__select-mode">
      <div className="deliverable-submit-modal__attachments-list">
        {attachments.map(attachment => (
          <div 
            key={attachment.id}
            className={`deliverable-submit-modal__attachment ${selectedAttachmentId === attachment.id ? 'deliverable-submit-modal__attachment--selected' : ''}`}
            onClick={() => setSelectedAttachmentId(attachment.id)}
          >
            <div className="deliverable-submit-modal__attachment-radio">
              <div className="deliverable-submit-modal__attachment-radio-inner" />
            </div>
            <div className="deliverable-submit-modal__attachment-info">
              <span className="deliverable-submit-modal__attachment-name">{attachment.filename}</span>
              <span className="deliverable-submit-modal__attachment-meta">
                {attachment.type} • {formatSize(attachment.size)}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SelectMode;
